// extracted by mini-css-extract-plugin
export default {"content":"style_content__vgw9H","leftSide":"style_leftSide__E9ASh","rightSide":"style_rightSide__hl5A4","type":"style_type__CVMcN"};